import request from '@/utils/request'

const payment = {
  // 查询付款单位列表
  listPayer(query) {
    return request({
      url: '/cont/payCompany/list',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 查询付款单位详细
  getPayer(contPayCompanyId) {
    return request({
      url: '/cont/payCompany/' + contPayCompanyId,
      method: 'get',
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 按合同id查询最新的一条打款记录,pc端
  getDataByContractId(contractId) {
    return request({
      url: '/cont/payment/getDataByContractId/' + contractId,
      method: 'get',
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 原新增付款单位
  addPayer(data) {
    console.log('payCompany:' + JSON.stringify(data))
    return request({
      url: '/cont/payCompany',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 修改付款单位
  updatePayer(data) {
    console.log('payCompany:' + JSON.stringify(data))
    return request({
      url: '/cont/payCompany',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 删除付款单位
  deletePayer(contPayCompanyId) {
    return request({
      url: '/cont/payCompany/' + contPayCompanyId,
      method: 'delete',
      options: {
        loading: true
      }
    })
  },
  // 查询渠道付款单位列表
  listChannelPayer(query) {
    return request({
      url: '/cont/payCompanyChannel/list',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 新增渠道付款单位
  addChannelPayer(data) {
    return request({
      url: '/cont/payCompanyChannel',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 修改渠道付款单位
  updateChannelPayer(data) {
    return request({
      url: '/cont/payCompanyChannel',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 删除渠道付款单位
  deleteChannelPayer(contPayCompanyId) {
    return request({
      url: '/cont/payCompanyChannel/' + contPayCompanyId,
      method: 'delete',
      options: {
        loading: true
      }
    })
  },
  // 查询执行客户信息列表
  listExecutive(query) {
    return request({
      url: '/cont/customer/list',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 根据付款单位及合同查询执行客户
  getExecCustomerByCustName(data) {
    return request({
      url: '/cont/customer/getExecCustomerByCustName',
      method: 'post',
      data: data
    })
  },
  // 查询执行客户详细
  getExecutive(execCustomerId) {
    return request({
      url: '/cont/customer/' + execCustomerId,
      method: 'get',
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 新增执行客户
  addExecutive(data) {
    return request({
      url: '/cont/customer',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 根据名字查询执行客户信息 判断是否已存在
  getExecCustomerByName(execCustomerName) {
    return request({
      url: '/cont/customer/getExecCustomerByName?execCustomerName=' + execCustomerName,
      method: 'get'
    })
  },
  // 修改执行客户
  updateExecutive(data) {
    return request({
      url: '/cont/customer',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 删除执行客户
  deleteExecutive(execCustomerId) {
    return request({
      url: '/cont/customer/' + execCustomerId,
      method: 'delete',
      options: {
        loading: true
      }
    })
  },
  // 上传审批附件
  uploadContractFile(data) {
    return request({
      url: '/common/upload',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 查询收款记录列表
  listPayment(query) {
    return request({
      url: '/cont/payment/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 查询收款记录详细
  getPayment(contIncomeId) {
    return request({
      url: '/cont/payment/' + contIncomeId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 新增收款记录
  addPayment(data) {
    return request({
      url: '/cont/payment',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 新增新增打款记录并添加资金去向记录
  addFlow(data) {
    return request({
      url: '/cont/payment/addFlow',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // // 收款类型
  // getIncomeType(data) {
  //   return request({
  //     url: '/cont/payment/getIncomeType',
  //     method: 'post',
  //     data: data
  //   })
  // },
  // 收款记录审核
  reviewerPayment(data) {
    return request({
      url: '/cont/payment/reviewer',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 修改收款记录
  updatePayment(data) {
    return request({
      url: '/cont/payment',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 删除收款记录
  deletePayment(contIncomeId) {
    return request({
      url: '/cont/payment/' + contIncomeId,
      method: 'delete',
      options: {
        loading: true
      }
    })
  },
  // 付款银行列表
  listPayBank(query) {
    return request({
      url: '/fina/account/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 查询打款记录数量
  getCountItem(query) {
    return request({
      url: '/cont/payment/getCountItem',
      method: 'get',
      params: query
    })
  },
  // 统计金额汇总
  getTotalMoney(query) {
    return request({
      url: '/cont/payment/getTotalMoney',
      method: 'get',
      params: query
    })
  },
  // 新增补充合同
  addAgreement(data) {
    return request({
      url: '/cont/newContract/supAdd',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },

  // 获取部门授信总额
  selectByDeptIdMoney(data) {
    return request({
      url: '/cont/advances/selectByDeptIdMoney',
      method: 'post',
      data: data
    })
  },
  // 获取部门累计授信总额
  selectByDeptIdMoneyAdd(data) {
    return request({
      url: '/cont/advances/selectByDeptIdMoneyAdd',
      method: 'post',
      data: data
    })
  },
  // 判断垫款是否逾期
  judgeAdvances(contractId) {
    return request({
      url: '/cont/advances/isExceedTime/' + contractId,
      method: 'get'
    })
  },
  // 渠道合同判断是否逾期,传执行客户id
  isExceedTimeChannel(execCustomerId) {
    return request({
      url: '/cont/advances/isExceedTimeChannel/' + execCustomerId,
      method: 'get'
    })
  },
  // 获取回款记录
  listDetailed(query) {
    return request({
      url: '/fina/detailed/list',
      method: 'get',
      params: query
    })
  },
  // 查询合同垫款信息列表
  listAdvances(query) {
    return request({
      url: '/cont/advances/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 查询合同垫款信息详情
  getAdvances(contAdvancesId) {
    return request({
      url: '/cont/advances/' + contAdvancesId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 新增合同垫款信息
  addAdvances(data) {
    return request({
      url: '/cont/advances',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 添加垫款时，如果有相同的合同（或执行客户），相同的金额提交审批时进行提示
  isAdvancesApproval(data) {
    return request({
      url: '/cont/advances/isAdvancesDataApproval',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 修改合同垫款信息
  updateAdvances(data) {
    return request({
      url: '/cont/advances',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 提交草稿合同垫款信息
  submitAdvances(data) {
    return request({
      url: '/cont/advances/submitAdvances',
      method: 'put',
      data: data
    })
  },
  // 删除合同垫款信息
  deleteAdvances(contAdvancesIds) {
    return request({
      url: '/cont/advances/' + contAdvancesIds,
      method: 'delete',
      options: {
        loading: true
      }
    })
  },
  // 撤回合同垫款信息
  revokeAdvances(data) {
    return request({
      url: '/cont/advances/cancel',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 获取垫款列表数量接口
  getCountAdvances(query) {
    return request({
      url: '/cont/advances/getCountItem',
      method: 'get',
      params: query

    })
  },
  // 垫款 部门批量审核
  batchDeptReview(data) {
    return request({
      url: '/cont/advances/batchDeptReview',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 获取上一条媒介确认合同垫款信息详细信息
  getLastInfo(val) {
    return request({
      url: '/cont/advances/getLastInfo/' + val,
      method: 'get',
      options: {
        loading: true
      }
    })
  },

  // 查询【微信支付】列表
  listPayOrde(query) {
    return request({
      url: '/fina/payOrder/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 获取【微信支付】详细信息
  getPayOrde(payOrderId) {
    return request({
      url: '/fina/payOrder/' + payOrderId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 新增【微信扫码支付】,分两步
  addQrCode(data) {
    return request({
      url: '/fina/payOrder',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 修改【微信扫码支付】
  updateQrCode(data) {
    return request({
      url: '/fina/payOrder',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 关闭【微信支付】，传payOrderId
  closePay(data) {
    return request({
      url: '/fina/payOrder/closePay',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 获取二维码
  getQrCode(data) {
    return request({
      url: '/fina/payOrder/getQrCode',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },

  // 新增微信退款订单
  addRefund(data) {
    return request({
      url: '/fina/refund',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 查询微信退款订单列表
  listRefund(query) {
    return request({
      url: '/fina/refund/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 获取本部门
  listDept(query) {
    return request({
      url: '/system/dept/listByDeptId',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },

  // 根据一个money获取另一个 payMoney  rechargeMoney
  //  计算垫款金额,传pay_money(或recharge_money)，contract_id
  getPayMoney(query) {
    return request({
      url: '/cont/advances/getPayMoney',
      method: 'get',
      params: query
    })
  },
  // 识别获取图片详细信息
  baiduOrc(data) {
    return request({
      url: '/scrm/baidu/baiduOrc',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },

  //  短信识别
  smsTell(data) {
    return request({
      url: '/cont/newIncome/smsTell',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '识别中'
      }
    })
  },
  // 查询新收款记录列表
  listNewIncome(query) {
    return request({
      url: '/cont/newIncome/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 查询记录数量
  newIncomeCount(query) {
    return request({
      url: '/cont/newIncome/newIncomeCount',
      method: 'get',
      params: query
    })
  },
  // 查询汇总金额
  newIncomeSumMoney(query) {
    return request({
      url: '/cont/newIncome/newIncomeSumMoney',
      method: 'get',
      params: query
    })
  },
  // 获取新收款记录详细信息
  getNewIncome(contNewIncomeId) {
    return request({
      url: '/cont/newIncome/' + contNewIncomeId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 新增新收款记录
  addNewIncome(data) {
    return request({
      url: '/cont/newIncome',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 修改新收款记录
  updateNewIncome(data) {
    return request({
      url: '/cont/newIncome',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 删除新收款记录
  deleteNewIncome(contNewIncomeId) {
    return request({
      url: '/cont/newIncome/' + contNewIncomeId,
      method: 'delete',
      options: {
        loading: true
      }
    })
  },

  // 根据收款获取合同列表
  newIncomeCont(data) {
    return request({
      url: '/cont/newIncome/getContractIdList',
      method: 'post',
      data: data
    })
  },
  // 公海收款获取合同列表
  newWatersIncomeCont(data) {
    return request({
      url: '/cont/newIncome/getWatersContractIdList',
      method: 'post',
      data: data
    })
  },
  // 收款类型
  // getIncomeType(data) {
  //   return request({
  //     url: '/cont/newIncome/getIncomeType',
  //     method: 'post',
  //     data: data
  //   })
  // },
  getIncomeType(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/getIncomeType',
      method: 'post',
      data: data
    })
  },

  // 新收款记录认领明细列表
  listNewIncomeDetail(query) {
    return request({
      url: '/cont/newIncomeDetail/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 获取新收款记录明细详细信息
  getNewIncomeDetail(contNewIncomeDetailId) {
    return request({
      url: '/cont/newIncomeDetail/' + contNewIncomeDetailId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 新增认领 要传contNewIncomeId.三种情况：status=1 正常认领 status=2 公海认领 status=3 不是我的
  addNewIncomeDetail(data) {
    return request({
      url: '/cont/newIncomeDetail',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 修改新收款记录明细
  updateNewIncomeDetail(data) {
    return request({
      url: '/cont/newIncomeDetail',
      method: 'put',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 删除新收款记录明细
  deleteNewIncomeDetail(contNewIncomeDetailIds) {
    return request({
      url: '/cont/newIncomeDetail/' + contNewIncomeDetailIds,
      method: 'delete',
      options: {
        loading: true
      }
    })
  },
  // 指定媒介
  designatedMedia(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/designatedMedia',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 财务确认，要传contNewIncomeId,contractId
  finaConfirm(data) {
    return request({
      url: '/cont/newIncomeDetail/finaConfirm',
      method: 'post',
      data: data
    })
  },
  // 提出异议，要传contNewIncomeId
  noAgreeMatch(data) {
    return request({
      url: '/cont/newIncomeDetail/noAgreeMatch',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 解除认领,要传contNewIncomeDetailId
  relieve(data) {
    return request({
      url: '/cont/newIncomeDetail/relieve',
      method: 'post',
      data: data
    })
  },
  // 重新发起(收款主表只有一个业务员不能有重新发起按钮),要传contNewIncomeDetailId
  reissue(data) {
    return request({
      url: '/cont/newIncomeDetail/reissue',
      method: 'post',
      data: data
    })
  },
  // 消息确认 传contNewIncomeMsgId
  msgConfirm(data) {
    return request({
      url: '/cont/newIncomeDetail/msgConfirm',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 传contNewIncomeId 返回有数据则显示待确认列表，无数据待确认列表隐藏
  noConfirmedList(data) {
    return request({
      url: '/cont/newIncomeDetail/noConfirmedList',
      method: 'post',
      data: data
    })
  },
  // 获取收款消息发送详细信息
  getMsg(contNewIncomeMsgId) {
    return request({
      url: '/cont/msg/' + contNewIncomeMsgId,
      method: 'get',
      options: {
        loading: true
      }
    })
  },
  // 统计已被认领的金额
  getGetTotalMoney(query) {
    return request({
      url: '/cont/newIncomeDetail/getGetTotalMoney',
      method: 'get',
      params: query
    })
  },
  // 传contNewIncomeId 返回有数据“不是我的按钮”隐藏
  notMine(data) {
    return request({
      url: '/cont/newIncomeDetail/notMine',
      method: 'post',
      data: data
    })
  },

  // 充值列表
  mediaListNewIncomeDetail(query) {
    return request({
      url: '/cont/newIncomeDetail/mediaList',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 获取数量
  mediaGetCountItem(query) {
    return request({
      url: '/cont/newIncomeDetail/getCountItem',
      method: 'get',
      params: query
    })
  },
  // 新增广告账号ID之前调用
  addAssociationFront(data) {
    return request({
      url: '/cont/association/addAssociationFront',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 根据合同ID新增广告账号ID
  addAssociation(data) {
    return request({
      url: '/cont/association/addAssociation',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '绑定账户ID中'
      }
    })
  },
  // 账户ID管理的列表接口
  listGroupAccountId(query) {
    return request({
      url: '/cont/association/listGroupAccountId',
      method: 'get',
      params: query
    })
  },
  // 根据项目ID、账户ID删除
  deleteByAccountId(data) {
    return request({
      url: '/cont/association/deleteByAccountId',
      method: 'post',
      data: data
    })
  },
  // 合同账户ID列表
  // listByContractId(query) {
  //   return request({
  //     url: '/cont/association/listByContractId',
  //     method: 'get',
  //     params: query
  //   })
  // },
  // 合同账户ID列表 新
  listByProjectId(query) {
    return request({
      url: '/cont/association/listByProjectId',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 根据认领人员userId获取该部门的媒介排班人员列表
  getListByUserId(data) {
    return request({
      url: '/cont/arrange/getListByUserId',
      method: 'post',
      data: data
    })
  },
  // 垫款合同获取返点
  // 根据合同ID、付款单位获取执行客户返点列表
  execListByContractId(data) {
    return request({
      url: '/cont/customeProint/listByContractId',
      method: 'post',
      data: data
    })
  },
  // 根据一个money获取另一个 payMoney  rechargeMoney
  // 计算帐户币金额,传payMoney(或rechargeMoney),contractId
  getPayMoneyNew(query) {
    return request({
      url: '/cont/contNewIncomeDetailExec/getPayMoney',
      method: 'get',
      params: query
    })
  },
  // 批量新增新收款记录明细执行明细帐户明细
  addBatch(data) {
    return request({
      url: '/cont/ContNewIncomeDetailExecAccount/addBatch',
      method: 'post',
      data: data
    })
  },
  getExecBatch(data) {
    return request({
      url: '/cont/execAccount/getExecBatch',
      method: 'post',
      data: data
    })
  },
  // 是否有媒介排班人员
  isMediaUser(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/isMediaUser',
      method: 'post',
      data: data
    })
  },
  // 新增收款记录并添加资金去向记录
  addFlowNew(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/addFlow',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 查询新收款记录明细执行明细列表
  listExecutiveNew(query) {
    return request({
      url: '/cont/contNewIncomeDetailExec/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 查询新收款记录明细执行明细列表
  listFlowList(query) {
    return request({
      url: '/cont/flow/list',
      method: 'get',
      params: query
    })
  },
  // 查询新收款记录明细执行明细列表的账户id列表
  listExecAccount(query) {
    return request({
      url: '/cont/execAccount/listCapitalFlow',
      method: 'get',
      params: query
    })
  },
  // 查询新收款记录明细执行明细列表的账户id列表
  // listExecAccount(query) {
  //   return request({
  //     url: '/cont/execAccount/list',
  //     method: 'get',
  //     params: query,
  //     options: {
  //       loading: true
  //     }
  //   })
  // },
  // 获取服务商ID列表
  getContTencentAccountTokenList(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/getContTencentAccountTokenList',
      method: 'post',
      data: data
    })
  },
  // 获取服务商子账号ID列表
  getSubAccountTokenList(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/getSubAccountTokenList',
      method: 'post',
      data: data
    })
  },
  // 媒介充值
  mediaConfirm(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/mediaConfirm',
      method: 'post',
      data: data,
      options: {
        loading: true
      }
    })
  },
  // 媒介驳回
  mediaReject(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/mediaReject',
      method: 'post',
      data: data
    })
  },
  // 新驳回
  mediaRejectNew(data) {
    return request({
      url: '/cont/execAccount/mediaReject',
      method: 'post',
      data: data
    })
  },
  // 获取驳回列表回显
  listFlowReject(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/addFlowReject',
      method: 'post',
      data: data
    })
  },
  // 详情 获取驳回人员信息
  getRejectMediaUser(data) {
    return request({
      url: '/cont/contNewIncomeDetailExec/getRejectMediaUser',
      method: 'post',
      data: data
    })
  },
  // 查询返点百分比列表
  getRebateList(query) {
    return request({
      url: '/cont/customeProint/list',
      method: 'get',
      params: query
    })
  },
  // 新增返点百分比
  addRebate(data, execCustomerId) {
    return request({
      url: '/cont/customeProint/' + execCustomerId,
      method: 'post',
      data: data
    })
  },

  // 销售认领/需求发送前调用接口  是否有垫款流程或未确认的提示信息
  claimingBefore(data) {
    return request({
      url: '/cont/newIncomeDetail/claimingBefore',
      method: 'post',
      data: data
    })
  },

  // 添加垫款获取垫款授信信息
  getAdvancesCredit(query) {
    return request({
      url: '/cont/advances/getAdvancesCredit',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },
  // 添加垫款获取部门垫款授信信息
  getDeptAdvancesData(query) {
    return request({
      url: '/cont/advances/getDeptAdvancesData',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },

  // 判断长期垫款还是垫款特批
  getAdvanceStatusLab(query) {
    return request({
      url: '/cont/advances/getAdvanceStatusLab',
      method: 'get',
      params: query
    })
  }
}

export default payment
